import { render, staticRenderFns } from "./AutomatorPointsList.vue?vue&type=template&id=3d0cd0f0&scoped=true&"
import script from "./AutomatorPointsList.vue?vue&type=script&lang=js&"
export * from "./AutomatorPointsList.vue?vue&type=script&lang=js&"
import style0 from "./AutomatorPointsList.vue?vue&type=style&index=0&id=3d0cd0f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0cd0f0",
  null
  
)

export default component.exports